import React, { useEffect } from "react";
import { useSelector } from "react-redux";

const Submit = () => {
  const { order_id, url } = useSelector((state) => state.buy);
  const { currentReturnBaseURL } = url;

  useEffect(() => {
    // set order_id for success page (store is removed when redirected to simplex page)
    localStorage.setItem("litewallet_order_id", order_id);

    const s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.innerHTML = `
        try {
            document.forms["payment_form"].submit();
        } catch {
            alert('something went wrong');
        }
        `;

    document.head.appendChild(s);
  });

  return (
    <>
      <form
        id="payment_form"
        action="https://checkout.simplexcc.com/payments/new"
        method="post"
      >
        <input type="hidden" name="version" value="1" />
        <input type="hidden" name="partner" value="litecoinfoundation" />
        <input type="hidden" name="payment_flow_type" value="wallet" />
        <input
          type="hidden"
          name="return_url_success"
          value={currentReturnBaseURL + "/success/"}
        />
        <input
          type="hidden"
          name="return_url_fail"
          value={currentReturnBaseURL + "/fail/"}
        />
        <input type="hidden" name="payment_id" value={order_id} />
      </form>
    </>
  );
};

export default Submit;
